import { render } from "./ComponentLoader.vue?vue&type=template&id=3336b266"
import script from "./ComponentLoader.vue?vue&type=script&lang=js"
export * from "./ComponentLoader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__